import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["product", "composition", "compositionCount", "people", "addPerson", "personTemplate", "additionalSection", "additionalRows", "additionalTemplate", "notice", "result", "receiptForm", "method", "cardInstallments", "mixed"]

  connect() {
    this.sequence = 0
    if (this.hasProductTarget) this.productChanged()
    this.receiptChanged()
  }

  invalidate() {
    if (this.hasNoticeTarget) this.noticeTarget.hidden = false
    if (this.hasResultTarget) this.resultTarget.hidden = true
    if (this.hasReceiptFormTarget) this.receiptFormTarget.querySelectorAll("input, select, button").forEach(input => { input.disabled = true })
  }

  loading() {
    this.invalidate()
    this.noticeTarget.textContent = "Consultando o cenário. Aguarde a cotação."
  }

  productChanged(event) {
    const option = this.productTarget.selectedOptions[0]
    const current = option.dataset.model === "adhesion_only"
    this.compositionTarget.hidden = current
    this.compositionCountTarget.max = option.dataset.max
    if (current) this.compositionCountTarget.value = "1"
    this.addPersonTarget.hidden = option.dataset.people !== "true"
    if (this.hasAdditionalSectionTarget) {
      const hasAdditionalRows = Array.from(this.additionalRowsTarget.querySelectorAll("[data-additional-row]")).some(row => !row.hidden)
      this.additionalSectionTarget.hidden = !option.dataset.additionals && !hasAdditionalRows
      this.additionalSectionTarget.querySelector("button[data-action='funerary-quote#addAdditional']").hidden = !option.dataset.additionals
      this.filterAdditionalOptions()
    }
    if (event) this.invalidate()
  }

  addPerson() {
    this.peopleTarget.insertAdjacentHTML("beforeend", this.personTemplateTarget.innerHTML.replaceAll("NEW_PERSON", `person_${++this.sequence}`))
    this.invalidate()
    this.peopleTarget.lastElementChild.querySelector("select").focus()
  }

  removePerson(event) { this.removeRow(event.target.closest("[data-person-row]")) }
  removeAdditional(event) { this.removeRow(event.target.closest("[data-additional-row]")) }

  removeRow(row) {
    row.querySelector("[data-destroy]").value = "1"
    row.hidden = true
    row.querySelectorAll("[required]").forEach(input => { input.required = false })
    this.invalidate()
  }

  addAdditional() {
    this.additionalRowsTarget.insertAdjacentHTML("beforeend", this.additionalTemplateTarget.innerHTML.replaceAll("NEW_ADDITIONAL", `additional_${++this.sequence}`))
    this.filterAdditionalOptions()
    this.invalidate()
  }

  filterAdditionalOptions() {
    const allowed = this.productTarget.selectedOptions[0].dataset.additionals.split(",")
    this.additionalRowsTarget.querySelectorAll("[data-additional-select]").forEach(select => {
      Array.from(select.options).forEach(option => {
        option.disabled = !!option.value && !allowed.includes(option.value)
        option.hidden = option.disabled
      })
    })
  }

  receiptChanged() {
    if (!this.hasMethodTarget) return
    const method = this.methodTarget.value
    const card = ["credit_card", "pos"].includes(method)
    this.cardInstallmentsTarget.hidden = !card
    if (!card) this.cardInstallmentsTarget.querySelector("input").value = "1"
    this.mixedTarget.hidden = method !== "misto"
    this.mixedTarget.disabled = method !== "misto"
  }

  tenderChanged(event) {
    event.target.closest("[data-tender-row]").querySelector("[data-tender-fields]").disabled = !event.target.checked
  }
}
